export default "/_next/static/sounds/tv_ambient_g3-5b483ed6991f8b762552ef9c1e34788c.mp3";